import { render, staticRenderFns } from "./BuyFrames.vue?vue&type=template&id=52a348db&"
import script from "./BuyFrames.vue?vue&type=script&lang=js&"
export * from "./BuyFrames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports